import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions, service } from "../model";
import { Modal } from "@mui/material";
import ModalConferma from "../components/Generics/ModalConferma";
import ModalSuccess from "../components/Generics/ModalSuccess";
import { CircularProgress } from "@mui/material";
import ModalError from "../components/Generics/ModalError";
import SummaryPracticeAdmin from "../components/Practice/summaryPracticeAdmin";
import BoxButtonAdmin from "../components/BoxButtonAdmin";
import PopupFeedbackSuccess from "../components/Generics/PopupFeedback";
import PopupFeedbackError from "../components/Generics/PopupFeedbackError";
import { generatePDF } from "../utils/generate_pdf";
import { generateOthePDF_CCK } from "../utils/other_generate_pdf";

const PracticeAdmin = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const containerRef = useRef(null);

  const practices = useSelector(
    (state) => state.user?.redux_object?.practices || []
  );

  const reduxObject = JSON.parse(localStorage.getItem("redux_object") || "{}");

  const [practice, setPractices] = useState(null);
  const [practice_object, setPractices_object] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [idPractice, setIdPractice] = useState(id || null);
  const [successSend, setSuccessSend] = useState(false);
  const [errorSend, setErrorSend] = useState(false);
  const [successNote, setSuccessNote] = useState(false);
  const [errorNote, setErrorNote] = useState(false);
  const [documentPractice, setDocumentPractice] = useState([]);
  const [documentPracticeClient, setDocumentPracticeClient] = useState([]);

  const [adminNotes, setAdminNotes] = useState("");

  useEffect(() => {
    if (id) {
      const practiceElement = practices.find(
        (practice) => practice.id === parseInt(id, 10)
      );

      setPractices_object(practiceElement);

      let parsedData = { files: [] };
      if (practiceElement?.original_name_attached) {
        try {
          parsedData = JSON.parse(practiceElement.original_name_attached);
        } catch (err) {
          console.error("Errore", err);
        }
      }
      const filesArray = parsedData?.files
        ? Object.values(parsedData.files)
        : [];
      setDocumentPractice(filesArray);

      let parsedDataClient = { files: [] };
      if (practiceElement?.new_customer_attached_np) {
        try {
          parsedDataClient = JSON.parse(
            practiceElement.new_customer_attached_np
          );
        } catch (err) {
          console.error("Errore", err);
        }
      }
      const filesArrayClient = parsedDataClient?.files
        ? Object.values(parsedDataClient.files)
        : [];
      setDocumentPracticeClient(filesArrayClient);

      if (practiceElement?.practice) {
        try {
          let parsedPractice = practiceElement.practice;
          while (typeof parsedPractice === "string") {
            parsedPractice = JSON.parse(parsedPractice);
          }

          const { 0: _, 1: __, ...cleanedPractice } = parsedPractice;
          setPractices(cleanedPractice);
        } catch (error) {
          console.error("Errore", error);
        }
      }
    }

    setIsLoading(false);
  }, [id, practices]);

  useEffect(() => {
    if (practice_object?.note_admin) {
      setAdminNotes(practice_object.note_admin);
    }
  }, [practice_object]);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalRemoveOpen, setModalRemoveOpen] = useState(false);

  const handleModalClick = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleModalRemoveClick = (objectInfo) => {
    setModalRemoveOpen(true);
  };

  const handleCloseRemoveModal = () => {
    setModalRemoveOpen(false);
  };

  const handleCloseSuccessSendModal = () => {
    setSuccessSend(false);
    window.location.href = "/";
  };

  const workedPractice = async () => {
    setModalOpen(false);
    setIsLoading(true);

    const pdfGenerate = generatePDF(
      practice?.practice_id,
      practice,
      practice_object,
      adminNotes,
      true
    );

    const pdfGenerateDailyReport = generateOthePDF_CCK(
      practice_object?.practice_id,
      practice,
      true
    );

    try {
      if (idPractice) {
        await service.workedPractice(
          idPractice,
          adminNotes?.trim() ? adminNotes : undefined,
          pdfGenerate
        );
        await service.sendPdfDailyReport(idPractice, pdfGenerateDailyReport);
        setTimeout(() => {
          setIsLoading(false);
          setSuccessSend(true);
        }, 3000);
      }
    } catch (error) {
      console.error(error);
      setErrorSend(true);
      setIsLoading(false);
    }
  };

  const deletePracticeCall = async () => {
    try {
      if (idPractice) {
        await service.delete(idPractice);
      }
      await dispatch(actions.getPractice());
    } catch (error) {
      console.error(error);
    } finally {
      setModalRemoveOpen(false);
      window.location.href = "/";
    }
  };

  const handleCloseErrorSendModal = () => {
    setErrorSend(false);
  };

  const saveNote = async (practice_id, adminNotes) => {
    if (practice_id && adminNotes.trim() !== "") {
      try {
        await service.updateAdmin(practice_id, adminNotes);
        setSuccessNote(true);
        setTimeout(() => setSuccessNote(false), 3000);
      } catch (error) {
        setErrorNote(true);
        console.error(error);
        setTimeout(() => setErrorNote(false), 3000);
      }
    } else {
      try {
        await service.updateAdmin(practice_id);
        setSuccessNote(true);
        setTimeout(() => setSuccessNote(false), 3000);
      } catch (error) {
        setErrorNote(true);
        console.error(error);
        setTimeout(() => setErrorNote(false), 3000);
      }
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
        }}
      >
        <Header />
        <div
          ref={containerRef}
          style={{
            flex: 1,
            overflowY: "auto",
          }}
        >
          <SummaryPracticeAdmin
            setAdminNote={setAdminNotes}
            saveNote={saveNote}
            practice_id={id}
            practice_object={practice_object}
            practice={practice}
            documentPractice={documentPractice}
            documentPracticeClient={documentPracticeClient}
          />
        </div>

        {practice_object?.practice_worked === 0 && (
          <BoxButtonAdmin
            removePractice={handleModalRemoveClick}
            handleModalClick={handleModalClick}
          />
        )}
      </div>
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <ModalConferma
          title="Approva pratica"
          descriptionOne="Attenzione! L'approvazione è un'azione irreversibile con cui si comunica al professionista di riferimento l'avvenuta apertura della pratica su Elibra."
          descriptionTwo="Sei sicuro di voler procedere?"
          copyButton="Sì, approva"
          confirm={workedPractice}
          onClose={handleCloseModal}
        />
      </Modal>
      <Modal open={modalRemoveOpen} onClose={handleCloseRemoveModal}>
        <ModalError
          modalInfo={true}
          title="Rifiuta pratica"
          descriptionOne="Attenzione! Rifiutando la pratica tutti i dati verranno eliminati in modo irreversibile."
          descriptionTwo="Dovrai contattare immediatamente il professionista di riferimento per spiegare le ragioni del rifiuto e invitarlo a compilare una nuova richiesta."
          descriptionThree="Sei sicuro di voler procedere?"
          copyButton="Sì, rifiuta"
          confirm={deletePracticeCall}
          onClose={handleCloseRemoveModal}
        />
      </Modal>
      {successSend && (
        <Modal open={successSend} onClose={handleCloseSuccessSendModal}>
          <ModalSuccess
            title="Pratica approvata con successo"
            descriptionOne="Una notifica è stata inviata al professionista di riferimento per comunicargli l'avvenuta approvazione."
            copyButton="Chiudi"
            confirm={handleCloseSuccessSendModal}
            onClose={handleCloseSuccessSendModal}
          />
        </Modal>
      )}
      {errorSend && (
        <Modal open={errorSend} onClose={handleCloseErrorSendModal}>
          <ModalError
            title="Invio non effettuato"
            descriptionOne="La tua richiesta di apertura pratica non può essere inoltrata a causa di un momentaneo errore tecnico."
            descriptionTwo="Ti invitiamo a riprovare tra qualche minuto."
            copyButton="Chiudi"
            confirm={handleCloseErrorSendModal}
            onClose={handleCloseErrorSendModal}
          />
        </Modal>
      )}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress style={{ color: "#1b2838" }} />
        </div>
      )}

      {successNote && (
        <div
          style={{
            width: "280px",
            position: "fixed",
            bottom: "-20px",
            left: "50%",
            backgroundColor: "#fff",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
            padding: "12px 10px",
            borderRadius: "0px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
            fontSize: "14px",
          }}
        >
          <PopupFeedbackSuccess />
        </div>
      )}

      {errorNote && (
        <div
          style={{
            width: "300px",
            position: "fixed",
            bottom: "-20px",
            left: "50%",
            backgroundColor: "#fff",
            transform: "translate(-50%, -50%)",
            zIndex: 1000,
            padding: "12px 10px",
            borderRadius: "0px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
            fontSize: "14px",
          }}
        >
          <PopupFeedbackError />
        </div>
      )}
    </>
  );
};

export default PracticeAdmin;
